import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import axios from "axios";
import { Link } from "react-router-dom";
import "./Slider2.scss";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { logo } from "../../../../assets";

const Slider2 = ({
  apiURL,
  data = [],
  useAPI = true,
  slidesToShow = 1,
  autoplay = true,
  autoplaySpeed = 3000,
  buttonText = "Discover",
  buttonIcon = null,
  manuallyFormatLink = (item) => "#",
  titleFormatter = (item) => item.name || "Untitled",
  subtitleFormatter = (item) => item.artist?.name || "Unknown Artist",
  defaultImage = logo,
}) => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    if (!useAPI) {
      setItems(data);
      return;
    }

    const fetchData = async () => {
      try {
        const res = await axios.get(apiURL);
        setItems((prevItems) => {
          const newData = res.data || [];
          if (JSON.stringify(prevItems) !== JSON.stringify(newData)) {
            return newData;
          }
          return prevItems;
        });
      } catch (err) {
        console.error("Slider error:", err);
      }
    };

    fetchData();
  }, [apiURL, useAPI]);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    arrows: true,
    autoplay,
    autoplaySpeed,
    slidesToShow,
    slidesToScroll: 1,
    customPaging: () => <div className="custom-dot"></div>,
  };

  return (
    <div className="slider-container">
      <Slider {...settings}>
        {items.map((item, index) => (
          <div className="slider-item" key={index}>
            {item.name ? (
              <div
                className="slider-image"
                style={{
                  backgroundImage: `linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.8)), 
                     url(${item.prev_img_url || defaultImage})`,
                  backgroundSize: item.prev_img_url ? "cover" : "contain",
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                  width: "100%",
                }}
              >
                <div className="slider_content">
                  <div className="content">
                    <div
                      className="artist-ava"
                      style={{
                        backgroundImage: `url(${item.prev_img_url || defaultImage})`,
                      }}
                    ></div>

                    <h3>{titleFormatter(item)}</h3>
                    <p>By {subtitleFormatter(item)}</p>
                  </div>

                  <Link
                    to={manuallyFormatLink(item)}
                    className="view-collection-button"
                  >
                    {buttonIcon && (
                      <img src={buttonIcon} alt="" className="icon-box" />
                    )}
                    {buttonText}
                  </Link>
                </div>
              </div>
            ) : (
              <div>No artwork available</div>
            )}
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default Slider2;
